import React from "react";
import ListItemText from "@material-ui/core/ListItemText";
import {CountdownTimer} from "./CountdownTimer";
import {BASE_URL_API, URL_GROUP_AVATAR} from "../Const";
import ListItem from "@material-ui/core/ListItem";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import AvatarIcon from "../assets/icons/avatar.svg";
import Divider from "@material-ui/core/Divider";

import GoldMedal from "../assets/icons/gold_medal.png"
import SilverMedal from "../assets/icons/silver_medal.png"
import BoronzMedal from "../assets/icons/boronz_medal.png"

export class WinnerComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lotteryInfo: {},
            time: {},
            seconds: 0,
            showWinners: false
        }

        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    audio = new Audio(this.props.url)

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    startTimer() {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        console.log(seconds)
        if (seconds === 0) {
            this.setState({
                showWinners: true,
            });
        }

        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
        }
    }

    diffDate(date) {
        if (date == null) return 0

        const today = new Date()
        const date2 = new Date(Date.parse(date));

        console.log(date, date2, today, (date2.getTime() - today.getTime()) / 1000)
        return parseInt((date2.getTime() - today.getTime()) / 1000)
    }


    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({time: timeLeftVar});
        fetch(BASE_URL_API + 'lottery', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code == '200') {
                        console.log(this.diffDate(results.data.end_time), "sdasdas")
                        this.setState({lotteryInfo: results.data, seconds: this.diffDate(results.data.end_time)})

                        this.startTimer()

                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }

    diffDate(date) {
        if (date == null) return 0

        const today = new Date()
        const date2 = new Date(Date.parse(date));

        console.log(date, date2, today, (date2.getTime() - today.getTime()) / 1000)
        return parseInt((date2.getTime() - today.getTime()) / 1000)
    }

    render() {

        return (
            <div style={{width: window.innerWidth, height: window.innerHeight}}>
                <video style={{width: "100%", height: "100%", objectFit: "cover", margin: 0, padding: 0}} autoPlay muted
                       loop
                       src="https://hamekara.com/winner_loop.mp4"/>


                {
                    (!this.state.showWinners) ? (
                        <div style={{
                            position: "absolute",
                            width: '100%',
                            height: '100%',
                            top: 0,
                            display: "flex",
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white'
                        }}>

                            <ListItemText>
                                <div>
                                    <audio ref="audio_tag" autoPlay loop>
                                        <source src="https://hamekara.com/tik_tok_audio.mp3" type="audio/mp3"/>
                                    </audio>
                                    <p align='center' style={{fontSize: window.innerWidth / 10}}>{this.state.time.s}</p>
                                </div>
                            </ListItemText>
                        </div>
                    ) : (
                        <div style={{
                            position: "absolute",
                            width: '100%',
                            height: '100%',
                            top: 0,
                            display: "flex",
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white'
                        }}>
                            <audio ref="audio_tag" autoPlay loop>
                                <source src="https://hamekara.com/firework_audio.mp3" type="audio/mp3"/>
                            </audio>

                            <Grid container style={{background: "rgba(0,0,0,0.5)"}}>
                                <Grid xs={3}>
                                    <img style={{
                                        borderRadius: '50%',
                                        width: 100,
                                        height: 100
                                    }}
                                         alt="avatar2"
                                         src={GoldMedal}/>

                                </Grid>

                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            ملیکا کبیری
                                        </p>
                                    </ListItemText>

                                </Grid>
                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: '#ffffff',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            0121***0905
                                        </p>
                                    </ListItemText>

                                </Grid>

                                <Grid item xs={3}/>


                                <Grid xs={3}>
                                    <img style={{
                                        borderRadius: '50%',
                                        width: 100,
                                        height: 100
                                    }}
                                         alt="avatar2"
                                         src={SilverMedal}/>

                                </Grid>

                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            عاطفه باقری
                                        </p>
                                    </ListItemText>

                                </Grid>
                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: '#ffffff',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            8775***0913
                                        </p>
                                    </ListItemText>

                                </Grid>

                                <Grid item xs={3}/>


                                <Grid xs={3}>
                                    <img style={{
                                        borderRadius: '50%',
                                        width: 100,
                                        height: 100
                                    }}
                                         alt="avatar2"
                                         src={BoronzMedal}/>

                                </Grid>

                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            مهرسا غلامی
                                        </p>
                                    </ListItemText>

                                </Grid>
                                <Grid item xs={3}>
                                    <ListItemText style={{align: 'right'}}>

                                        <p style={{
                                            overflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: '#ffffff',
                                            fontSize: window.innerWidth / 36,
                                        }}
                                           align='right'>
                                            2677***0913
                                        </p>
                                    </ListItemText>

                                </Grid>

                                <Grid item xs={3}/>

                            </Grid>

                        </div>)}

            </div>
        );

    }

}
